import { TreeNode } from "@/types/tree";
import {
  getColumnWidth,
  rewidthIfColumnsNotAddUpTo100
} from "@/lib/columns/helpers";
import { getOnCanvasColumnMinWidthBasedOnPadding } from "./canvas";
import { changeColumnWidthAndCommitToStore } from "./store";
import { parseFloatAndFixTo2Digits } from "@/util/math";

const DEFAULT_MIN_WIDTH = 20;

export type NewColumnWidths = {
  resizedWidth: number;
  siblingWidth: number;
};

export function resizeTwoColumnsAndCommit(
  columns: TreeNode,
  columnToResizeIndex: number,
  newWidth: number,
  adjustSibling: "right" | "left"
): NewColumnWidths | false {
  const siblingToResizeIndex =
    adjustSibling === "right"
      ? columnToResizeIndex + 1
      : columnToResizeIndex - 1;
  const siblingToResize = columns.children[siblingToResizeIndex];
  const columnToResize = columns.children[columnToResizeIndex];

  if (!columnToResize || !siblingToResize) return false;
  if (columnToResizeIndex < 0 || siblingToResizeIndex < 0) return false;

  const columnMinWidth =
    getOnCanvasColumnMinWidthBasedOnPadding(columnToResize);
  const siblingMinWidth =
    getOnCanvasColumnMinWidthBasedOnPadding(siblingToResize);

  let MIN_WIDTH = DEFAULT_MIN_WIDTH;

  if (columnMinWidth !== false && siblingMinWidth !== false) {
    MIN_WIDTH = Math.max(columnMinWidth, siblingMinWidth);
  }

  let unavailableWidth =
    100 - getColumnWidth(columnToResize) - getColumnWidth(siblingToResize);

  let siblingWidth = 100 - unavailableWidth - newWidth;

  if (newWidth < MIN_WIDTH) {
    newWidth = MIN_WIDTH;
    siblingWidth = 100 - unavailableWidth - newWidth;
  }

  if (siblingWidth < MIN_WIDTH) {
    siblingWidth = MIN_WIDTH;
    newWidth = 100 - unavailableWidth - siblingWidth;
  }

  if (unavailableWidth > 100 - MIN_WIDTH * 2) {
    newWidth = (100 - unavailableWidth) / 2;
    siblingWidth = (100 - unavailableWidth) / 2;
  }

  newWidth = parseFloatAndFixTo2Digits(newWidth);
  siblingWidth = parseFloatAndFixTo2Digits(siblingWidth);
  unavailableWidth = parseFloatAndFixTo2Digits(unavailableWidth);

  if (newWidth + siblingWidth + unavailableWidth !== 100) {
    siblingWidth = 100 - unavailableWidth - newWidth;
    siblingWidth = parseFloatAndFixTo2Digits(siblingWidth);
  }

  changeColumnWidthAndCommitToStore(columnToResize.id, newWidth);
  changeColumnWidthAndCommitToStore(siblingToResize.id, siblingWidth);

  rewidthIfColumnsNotAddUpTo100(columns);

  return {
    resizedWidth: newWidth,
    siblingWidth: siblingWidth
  };
}
